export default __webpack_public_path__ + "static/media/back-arrow.96cdc1f0.svg";